export const PAGES = {
	DEFAULT: 'DEFAULT',
	COUNTRY: 'COUNTRY',
	SUCCESS: 'SUCCESS',
};
